export default "__VITE_ASSET__B6ZtwL0m__"